<mat-accordion class="d-flex flex-column" displayMode="flat" [multi]="true">
    <mat-expansion-panel class="view-expansion-panel" [expanded]="true">
        <mat-expansion-panel-header collapsedHeight="48px" expandedHeight="48px">
            <mat-panel-title>Programare</mat-panel-title>
        </mat-expansion-panel-header>
        <mat-list>
            <div class="p-0">
                <app-appointment [appointment]="appointment" [cerere]="cerere"></app-appointment>
            </div>

            <mat-list-item class="view-mat-list-item">
                <span matListItemTitle> Locația dorită </span>
                <span matListItemLine> {{ cerere.locatie }} </span>
            </mat-list-item>

            <ng-container *ngIf="cerere.informatii">
                <mat-list-item *ngFor="let field of getCurrentFormFields()" class="view-mat-list-item">
                    <span matListItemTitle>
                        {{ field.label }}
                    </span>
                    <span matListItemLine>
                        <ng-container [ngSwitch]="field.type">
                            <ng-container *ngSwitchCase="'boolean'">
                                {{ cerere.informatii[field.value] ? 'Da' : 'Nu' }}
                            </ng-container>

                            <ng-container *ngSwitchCase="'date'">
                                {{ cerere.informatii[field.value] ? (
                                cerere.informatii[field.value] | date:'dd-MM-yyyy HH:mm'
                                ) : '-' }}
                            </ng-container>

                            <ng-container *ngSwitchDefault>
                                {{
                                cerere.informatii[field.value] ? cerere.informatii[field.value] : '-'
                                }}
                            </ng-container>

                            <ng-container *ngSwitchCase="'situatie_militara'">
                                {{ mapValueToName(cerere.informatii[field.value], militaryStatuses) }}
                            </ng-container>

                            <ng-container *ngSwitchCase="'rang_militar'">
                                {{ mapValueToName(cerere.informatii[field.value], militaryRanks) }}
                            </ng-container>

                            <ng-container *ngSwitchCase="'regim_matrimonial'">
                                {{ mapValueToName(cerere.informatii[field.value], matrimonialRegimes) }}
                            </ng-container>
                        </ng-container>
                    </span>
                </mat-list-item>
            </ng-container>

            <ng-container *ngIf="cerere.programare_eveniment">
                <mat-list-item class="view-mat-list-item">
                    <span matListItemTitle>
                        Dată programare eveniment
                    </span>
                    <span matListItemLine>
                        {{ cerere.programare_eveniment.data_ora | date:'dd-MM-yyyy' }}
                    </span>
                </mat-list-item>
                <mat-list-item class="view-mat-list-item">
                    <span matListItemTitle>
                        Oră programare eveniment
                    </span>
                    <span matListItemLine>
                        {{ cerere.programare_eveniment.data_ora | date:'HH:mm' }}
                    </span>
                </mat-list-item>
            </ng-container>

            <ng-container *ngIf="cerere.programare_documente">
                <mat-list-item class="view-mat-list-item">
                    <span matListItemTitle>
                        Dată programare depunere documente
                    </span>
                    <span matListItemLine>
                        {{ cerere.programare_documente.data_ora | date:'dd-MM-yyyy' }}
                    </span>
                </mat-list-item>
                <mat-list-item class="view-mat-list-item">
                    <span matListItemTitle>
                        Oră programare depunere documente
                    </span>
                    <span matListItemLine>
                        {{ cerere.programare_documente.data_ora | date:'HH:mm' }}
                    </span>
                </mat-list-item>
            </ng-container>

            <mat-list-item class="view-mat-list-item">
                <span matListItemTitle>
                    Tip cerere
                </span>
                <span matListItemLine>
                    {{ cerere.type_denumire || '&nbsp;' }}
                </span>
            </mat-list-item>
        </mat-list>
    </mat-expansion-panel>

    <mat-expansion-panel class="view-expansion-panel">
        <mat-expansion-panel-header collapsedHeight="48px" expandedHeight="48px">
            <mat-panel-title>Date de contact</mat-panel-title>
        </mat-expansion-panel-header>
        <mat-list>
            <mat-list-item class="view-mat-list-item">
                <span matListItemTitle>
                    Nume
                </span>
                <span matListItemLine>
                    {{ cerere.cetatean?.nume || '&nbsp;' }}
                </span>
            </mat-list-item>

            <mat-list-item class="view-mat-list-item">
                <span matListItemTitle>
                    Prenume
                </span>
                <span matListItemLine>
                    {{ cerere.cetatean?.prenume || '&nbsp;' }}
                </span>
            </mat-list-item>

            <mat-list-item class="view-mat-list-item">
                <span matListItemTitle>
                    CNP
                </span>
                <span matListItemLine>
                    {{ cerere.cetatean?.cnp || '&nbsp;' }}
                </span>
            </mat-list-item>

            <mat-list-item class="view-mat-list-item">
                <span matListItemTitle>
                    Email
                </span>
                <span matListItemLine>
                    {{ cerere.cetatean?.email || '&nbsp;' }}
                </span>
            </mat-list-item>

            <mat-list-item class="view-mat-list-item">
                <span matListItemTitle>
                    Telefon
                </span>
                <span matListItemLine>
                    {{ cerere.cetatean?.telefon || '&nbsp;' }}
                </span>
            </mat-list-item>

            <mat-list-item *ngIf="cerere.cetatean?.nume_tata" class="view-mat-list-item">
                <span matListItemTitle>
                    Prenume tată
                </span>
                <span matListItemLine>
                    {{ cerere.cetatean?.nume_tata || '&nbsp;' }}
                </span>
            </mat-list-item>

            <mat-list-item *ngIf="cerere.cetatean?.nume_mama" class="view-mat-list-item">
                <span matListItemTitle>
                    Prenume mamă
                </span>
                <span matListItemLine>
                    {{ cerere.cetatean?.nume_mama || '&nbsp;' }}
                </span>
            </mat-list-item>
        </mat-list>
    </mat-expansion-panel>

    <mat-expansion-panel *ngIf="cerere.adresa_domiciliu" class="view-expansion-panel">
        <mat-expansion-panel-header collapsedHeight="48px" expandedHeight="48px">
            <mat-panel-title>Adresă domiciliu</mat-panel-title>
        </mat-expansion-panel-header>
        <app-address [address]="cerere.adresa_domiciliu"></app-address>
    </mat-expansion-panel>

    <mat-expansion-panel *ngIf="cerere.adresa_domiciliu_anterior" class="view-expansion-panel">
        <mat-expansion-panel-header collapsedHeight="48px" expandedHeight="48px">
            <mat-panel-title>Adresă domiciliu anterior</mat-panel-title>
        </mat-expansion-panel-header>
        <app-address [address]="cerere.adresa_domiciliu_anterior"></app-address>
    </mat-expansion-panel>

    <mat-expansion-panel *ngIf="cerere.adresa_resedinta" class="view-expansion-panel">
        <mat-expansion-panel-header collapsedHeight="48px" expandedHeight="48px">
            <mat-panel-title>Adresă reședință</mat-panel-title>
        </mat-expansion-panel-header>
        <app-address [address]="cerere.adresa_resedinta"></app-address>
    </mat-expansion-panel>

    <mat-expansion-panel *ngIf="cerere.prim_sot" class="view-expansion-panel">
        <mat-expansion-panel-header collapsedHeight="48px" expandedHeight="48px">
            <mat-panel-title>Soțul</mat-panel-title>
        </mat-expansion-panel-header>
        <app-spouse [spouse]="cerere.prim_sot"></app-spouse>
    </mat-expansion-panel>

    <mat-expansion-panel *ngIf="cerere.second_sot" class="view-expansion-panel">
        <mat-expansion-panel-header collapsedHeight="48px" expandedHeight="48px">
            <mat-panel-title>Soția</mat-panel-title>
        </mat-expansion-panel-header>
        <app-spouse [spouse]="cerere.second_sot"></app-spouse>
    </mat-expansion-panel>

    <ng-container *ngIf="cerere.copii && cerere.copii.length">
        <mat-expansion-panel *ngFor="let copil of cerere.copii; index as index" class="view-expansion-panel">
            <mat-expansion-panel-header collapsedHeight="48px" expandedHeight="48px">
                <mat-panel-title>Copil #{{ index + 1 }}</mat-panel-title>
            </mat-expansion-panel-header>
            <mat-list>
                <mat-list-item class="view-mat-list-item">
                    <span matListItemTitle>
                        Nume
                    </span>
                    <span matListItemLine>
                        {{ copil.nume + ' ' + copil.prenume }}
                    </span>
                </mat-list-item>

                <mat-list-item class="view-mat-list-item">
                    <span matListItemTitle>
                        Data nașterii
                    </span>
                    <span matListItemLine>
                        {{ copil.data_nasterii || '-' }}
                    </span>
                </mat-list-item>

                <mat-list-item class="view-mat-list-item">
                    <span matListItemTitle>
                        Locul nașterii
                    </span>
                    <span matListItemLine>
                        {{ (copil.judet && copil.oras) ? (copil.judet + ", " + copil.oras) : '-' }}
                    </span>
                </mat-list-item>

                <mat-list-item class="view-mat-list-item" *ngIf="copil.certificat_nastere">
                    <span matListItemTitle>
                        Certificat naștere
                    </span>
                    <span matListItemLine>
                        {{ copil.certificat_nastere }}
                    </span>
                </mat-list-item>

                <mat-list-item class="view-mat-list-item" *ngIf="copil.nume_tata">
                    <span matListItemTitle>
                        Nume tată
                    </span>
                    <span matListItemLine>
                        {{ copil.nume_tata }}
                    </span>
                </mat-list-item>

                <mat-list-item class="view-mat-list-item" *ngIf="copil.nume_mama">
                    <span matListItemTitle>
                        Nume mamă
                    </span>
                    <span matListItemLine>
                        {{ copil.nume_mama }}
                    </span>
                </mat-list-item>
            </mat-list>
        </mat-expansion-panel>
    </ng-container>

    <mat-expansion-panel *ngFor="let docTypeKey of getDocumentTypeKeys()" class="view-expansion-panel">
        <mat-expansion-panel-header collapsedHeight="48px" expandedHeight="48px">
            <mat-panel-title>{{ cerere.documente[docTypeKey].name }}</mat-panel-title>
        </mat-expansion-panel-header>
        <mat-action-list>
            <mat-list-item class="view-mat-list-item" *ngFor="let docKey of getDocumentKeys(docTypeKey)">
                <span matListItemTitle>
                    {{ cerere.documente[docTypeKey].documente[docKey].name }}
                </span>
                <span matListItemLine *ngFor="let file of cerere.documente[docTypeKey].documente[docKey].files">
                    <button class="btn btn-light upload-btn" (click)="downloadDocument(file)">
                        <span class="upload__text">
                            <img src="assets/icons/icon-download-blue.svg" alt="Descarcă" />
                            &nbsp;{{ file.name }}
                        </span>
                    </button>
                </span>
            </mat-list-item>
        </mat-action-list>
    </mat-expansion-panel>

    <mat-expansion-panel class="view-expansion-panel">
        <mat-expansion-panel-header collapsedHeight="48px" expandedHeight="48px">
            <mat-panel-title>Registratură</mat-panel-title>
        </mat-expansion-panel-header>
        <mat-list>
            <mat-list-item class="view-mat-list-item">
                <span matListItemTitle>
                    ID Ticket (registratură)
                </span>
                <span matListItemLine>
                    <!-- ticketId ???? -->
                    {{ cerere.registratura?.registration_number || '&nbsp;' }}
                </span>
            </mat-list-item>

            <mat-list-item class="view-mat-list-item">
                <span matListItemTitle>
                    ID Responsabil
                </span>
                <span matListItemLine>
                    {{ cerere.id_user_assigned || '&nbsp;' }}
                </span>
            </mat-list-item>

            <mat-list-item class="view-mat-list-item">
                <span matListItemTitle>
                    Responsabil
                </span>
                <span matListItemLine>
                    {{ cerere.user_assigned || '&nbsp;' }}
                </span>
            </mat-list-item>
        </mat-list>
    </mat-expansion-panel>
</mat-accordion>